import React from 'react';
import './Select.css';

const Select = ({ 
  label,
  value,
  onChange,
  options,
  placeholder = "Sélectionner une option",
  required = false,
  error,
  disabled = false,
  id,
  name,
  className = '',
  ...props
}) => {
  const selectId = id || name || Math.random().toString(36).substr(2, 9);
  
  const classes = [
    'ui-select__field',
    error ? 'ui-select__field--error' : '',
    disabled ? 'ui-select__field--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="ui-select">
      {label && (
        <label htmlFor={selectId} className="ui-select__label">
          {label}
          {required && <span className="ui-select__required">*</span>}
        </label>
      )}
      <div className="ui-select__wrapper">
        <select
          id={selectId}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          name={name}
          className={classes}
          {...props}
        >
          <option value="">{placeholder}</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {error && <span className="ui-select__error">{error}</span>}
    </div>
  );
};

export default Select; 